import { connect } from 'react-redux';

import MedicalInformationBlock from 'components/MedicalInformationBlock';

import { getPatientPageUrlParams } from 'store/selectors/router';
import { getFrailityScore } from 'store/selectors/questionnaireResponses';

const mapStateToProps = state => {
  const { patientId } = getPatientPageUrlParams(state);
  return {
    data: getFrailityScore(patientId)(state),
  };
};

export default connect(mapStateToProps)(MedicalInformationBlock);
